import {EnumValueDomainModel} from "./enum-value.domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";

export class EnumValueViewModel extends BaseViewModel {
  domainModel: EnumValueDomainModel;
  value: Number;
  shortName: String;
  aliasName: String;

  constructor(domainModel: EnumValueDomainModel) {
    super(domainModel);

    this.value = domainModel.value;
    this.shortName = domainModel.shortName;
    this.aliasName = domainModel.aliasName;
  }
}
